import * as Yup from 'yup';

export const DepartmentSchema = Yup.object().shape({
  depName: Yup.string().required('El nombre es requerido.'),
  depDescription: Yup.string(),
  parentId: Yup.number().nullable(),
  statusId: Yup.number().required('El estado del permiso es requerido.'),
});
